import { configureStore } from '@reduxjs/toolkit';
import { authenticationApi } from 'apis/authenticationApi';
import { createEpicMiddleware } from 'redux-observable';
import { rootEpic, rootReducer } from './root';
import {companiesApi} from "apis/companiesApi";
import {kpiApi} from "apis/kpiApi";
import {priorityApi} from "apis/priorityApi";
import {samApi} from "../apis/samApi";
import {departmentApi} from "../apis/departmentApi";
import {locationApi} from "../apis/locationApi";

export default function configureAppStore() {
    // Create the epic middleware that contains axios instance we will use for any
    // communication with services.  This also opens up the ability to test epics
    const epicMiddleware = createEpicMiddleware();

    // Configure the redux store with our middleware and root reducer
    const store = configureStore({
        reducer: rootReducer,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                serializableCheck: false
            })
            .concat(authenticationApi.middleware)
            .concat(companiesApi.middleware)
            .concat(kpiApi.middleware)
            .concat(priorityApi.middleware)
            .concat(samApi.middleware)
            .concat(departmentApi.middleware)
            .concat(locationApi.middleware)
            .concat(epicMiddleware)
    });

    // Setup redux observables with the root epic
    epicMiddleware.run(rootEpic);

    return store;
}